import { createContext, useContext } from 'react';

export const PlanningContext = createContext(null);

export const usePlanningContext = () => useContext(PlanningContext);

export default PlanningContext;
